import { Link } from "react-router-dom";
import logoIcon from "@/assets/logo-icon.webp";

const footerLinks = {
  Platform: [
    { label: "Blog", href: "/blog" },
    { label: "Resources", href: "/#resources" },
    { label: "Use Cases", href: "/#use-cases" },
    { label: "Newsletter", href: "/#newsletter" },
  ],
  Topics: [
    { label: "90-Day Launch Guide", href: "/blog/launch-citizen-development-program-90-days" },
    { label: "Vibe Coding Explained", href: "/blog/what-is-vibe-coding-complete-guide" },
    { label: "AI Workflow Automation", href: "/blog/5-ai-workflows-non-developers-build-today" },
    { label: "IT Governance Framework", href: "/blog/governance-framework-makes-it-say-yes" },
  ],
  Rechtliches: [
    { label: "Impressum", href: "/impressum" },
    { label: "Datenschutz", href: "/datenschutz" },
    { label: "FAQ", href: "/#faq" },
    { label: "Kontakt", href: "mailto:hello@citizendevelopers.app" },
  ],
};

const Footer = () => (
  <footer className="border-t border-border bg-card">
    <div className="container py-16">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <div className="mb-4">
            <img src={logoIcon} alt="CitizenDevelopers Logo" width={80} height={80} className="h-16 w-auto" loading="lazy" />
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Free guides, templates, and weekly insights for citizen development and vibe coding.
          </p>
        </div>
        {Object.entries(footerLinks).map(([title, links]) => (
          <div key={title}>
            <p className="text-sm font-semibold text-foreground mb-5 font-sans uppercase tracking-wide">
              {title}
            </p>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="mt-14 pt-8 border-t border-border flex flex-col sm:flex-row justify-between items-center gap-4">
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} CitizenDevelopers.app — All rights reserved.
        </p>
        <div className="flex items-center gap-4 text-xs text-muted-foreground">
          <Link to="/impressum" rel="nofollow" className="hover:text-primary transition-colors">Impressum</Link>
          <Link to="/datenschutz" rel="nofollow" className="hover:text-primary transition-colors">Datenschutz</Link>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
